// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file thru/core/v1/transaction.proto (package thru.core.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../../buf/validate/validate_pb";
import { file_google_api_field_behavior } from "../../../google/api/field_behavior_pb";
import { file_thru_core_v1_types } from "./types_pb";
import type { Pubkey, Signature } from "../../common/v1/primitives_pb";
import { file_thru_common_v1_primitives } from "../../common/v1/primitives_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file thru/core/v1/transaction.proto.
 */
export const file_thru_core_v1_transaction: GenFile = /*@__PURE__*/
  fileDesc("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", [file_buf_validate_validate, file_google_api_field_behavior, file_thru_core_v1_types, file_thru_common_v1_primitives]);

/**
 * TransactionHeader carries structured metadata for a transaction.
 *
 * @generated from message thru.core.v1.TransactionHeader
 */
export type TransactionHeader = Message<"thru.core.v1.TransactionHeader"> & {
  /**
   * @generated from field: thru.common.v1.Signature fee_payer_signature = 1;
   */
  feePayerSignature?: Signature | undefined;

  /**
   * @generated from field: uint32 version = 2;
   */
  version: number;

  /**
   * @generated from field: uint32 flags = 3;
   */
  flags: number;

  /**
   * @generated from field: uint32 readwrite_accounts_count = 4;
   */
  readwriteAccountsCount: number;

  /**
   * @generated from field: uint32 readonly_accounts_count = 5;
   */
  readonlyAccountsCount: number;

  /**
   * @generated from field: uint32 instruction_data_size = 6;
   */
  instructionDataSize: number;

  /**
   * @generated from field: uint32 requested_compute_units = 7;
   */
  requestedComputeUnits: number;

  /**
   * @generated from field: uint32 requested_state_units = 8;
   */
  requestedStateUnits: number;

  /**
   * @generated from field: uint32 requested_memory_units = 9;
   */
  requestedMemoryUnits: number;

  /**
   * @generated from field: uint32 expiry_after = 10;
   */
  expiryAfter: number;

  /**
   * @generated from field: uint64 fee = 11;
   */
  fee: bigint;

  /**
   * @generated from field: uint64 nonce = 12;
   */
  nonce: bigint;

  /**
   * @generated from field: uint64 start_slot = 13;
   */
  startSlot: bigint;

  /**
   * @generated from field: thru.common.v1.Pubkey fee_payer_pubkey = 14;
   */
  feePayerPubkey?: Pubkey | undefined;

  /**
   * @generated from field: thru.common.v1.Pubkey program_pubkey = 15;
   */
  programPubkey?: Pubkey | undefined;

  /**
   * Chain identifier to prevent transaction replay across different chains.
   *
   * @generated from field: uint32 chain_id = 16;
   */
  chainId: number;
};

/**
 * Describes the message thru.core.v1.TransactionHeader.
 * Use `create(TransactionHeaderSchema)` to create a new message.
 */
export const TransactionHeaderSchema: GenMessage<TransactionHeader> = /*@__PURE__*/
  messageDesc(file_thru_core_v1_transaction, 0);

/**
 * TransactionExecutionResult captures execution outcomes.
 *
 * @generated from message thru.core.v1.TransactionExecutionResult
 */
export type TransactionExecutionResult = Message<"thru.core.v1.TransactionExecutionResult"> & {
  /**
   * @generated from field: uint32 consumed_compute_units = 1;
   */
  consumedComputeUnits: number;

  /**
   * @generated from field: uint32 consumed_memory_units = 2;
   */
  consumedMemoryUnits: number;

  /**
   * @generated from field: uint32 consumed_state_units = 3;
   */
  consumedStateUnits: number;

  /**
   * @generated from field: uint64 user_error_code = 4;
   */
  userErrorCode: bigint;

  /**
   * @generated from field: thru.core.v1.TransactionVmError vm_error = 5;
   */
  vmError: TransactionVmError;

  /**
   * @generated from field: uint64 execution_result = 6;
   */
  executionResult: bigint;

  /**
   * @generated from field: uint32 pages_used = 7;
   */
  pagesUsed: number;

  /**
   * @generated from field: uint32 events_count = 8;
   */
  eventsCount: number;

  /**
   * @generated from field: uint32 events_size = 9;
   */
  eventsSize: number;

  /**
   * @generated from field: repeated thru.common.v1.Pubkey readwrite_accounts = 10;
   */
  readwriteAccounts: Pubkey[];

  /**
   * @generated from field: repeated thru.common.v1.Pubkey readonly_accounts = 11;
   */
  readonlyAccounts: Pubkey[];

  /**
   * @generated from field: repeated thru.core.v1.TransactionEvent events = 12;
   */
  events: TransactionEvent[];

  /**
   * Account index of the program that caused the error (revert, fault, etc.).
   * Only meaningful when vm_error indicates a failure.
   *
   * @generated from field: uint32 error_program_acc_idx = 13;
   */
  errorProgramAccIdx: number;

  /**
   * The nonce the runtime requires for the next transaction from this fee
   * payer, as of this transaction's execution. Populated ONLY when vm_error is
   * TRANSACTION_VM_ERROR_NONCE_TOO_LOW or TRANSACTION_VM_ERROR_NONCE_TOO_HIGH;
   * absent otherwise. A nonce reject does not advance the nonce, so retrying
   * with this value is correct.
   *
   * This is not necessarily the account's live nonce by the time you read it:
   * another transaction from the same fee payer may have landed since. Treat it
   * as a correction to retry against, not a reservation. For a fee payer
   * restored by a creation state proof it is 0, and no account exists yet.
   *
   * @generated from field: optional uint64 fee_payer_expected_nonce = 14;
   */
  feePayerExpectedNonce?: bigint | undefined;
};

/**
 * Describes the message thru.core.v1.TransactionExecutionResult.
 * Use `create(TransactionExecutionResultSchema)` to create a new message.
 */
export const TransactionExecutionResultSchema: GenMessage<TransactionExecutionResult> = /*@__PURE__*/
  messageDesc(file_thru_core_v1_transaction, 1);

/**
 * TransactionEvent describes an event emitted during transaction execution.
 *
 * @generated from message thru.core.v1.TransactionEvent
 */
export type TransactionEvent = Message<"thru.core.v1.TransactionEvent"> & {
  /**
   * @generated from field: string event_id = 1;
   */
  eventId: string;

  /**
   * @generated from field: uint32 call_idx = 2;
   */
  callIdx: number;

  /**
   * @generated from field: uint32 program_idx = 3;
   */
  programIdx: number;

  /**
   * @generated from field: thru.common.v1.Pubkey program = 4;
   */
  program?: Pubkey | undefined;

  /**
   * @generated from field: bytes payload = 5;
   */
  payload: Uint8Array;
};

/**
 * Describes the message thru.core.v1.TransactionEvent.
 * Use `create(TransactionEventSchema)` to create a new message.
 */
export const TransactionEventSchema: GenMessage<TransactionEvent> = /*@__PURE__*/
  messageDesc(file_thru_core_v1_transaction, 2);

/**
 * Transaction describes a fully decoded transaction resource.
 *
 * @generated from message thru.core.v1.Transaction
 */
export type Transaction = Message<"thru.core.v1.Transaction"> & {
  /**
   * @generated from field: thru.common.v1.Signature signature = 1;
   */
  signature?: Signature | undefined;

  /**
   * @generated from field: thru.core.v1.TransactionHeader header = 2;
   */
  header?: TransactionHeader | undefined;

  /**
   * @generated from field: optional bytes body = 3;
   */
  body?: Uint8Array | undefined;

  /**
   * @generated from field: optional thru.core.v1.TransactionExecutionResult execution_result = 4;
   */
  executionResult?: TransactionExecutionResult | undefined;

  /**
   * @generated from field: optional uint64 slot = 5;
   */
  slot?: bigint | undefined;

  /**
   * @generated from field: optional uint32 block_offset = 6;
   */
  blockOffset?: number | undefined;
};

/**
 * Describes the message thru.core.v1.Transaction.
 * Use `create(TransactionSchema)` to create a new message.
 */
export const TransactionSchema: GenMessage<Transaction> = /*@__PURE__*/
  messageDesc(file_thru_core_v1_transaction, 3);

/**
 * RawTransaction provides direct access to serialized transaction bytes.
 *
 * @generated from message thru.core.v1.RawTransaction
 */
export type RawTransaction = Message<"thru.core.v1.RawTransaction"> & {
  /**
   * @generated from field: thru.common.v1.Signature signature = 1;
   */
  signature?: Signature | undefined;

  /**
   * @generated from field: bytes raw_transaction = 2;
   */
  rawTransaction: Uint8Array;
};

/**
 * Describes the message thru.core.v1.RawTransaction.
 * Use `create(RawTransactionSchema)` to create a new message.
 */
export const RawTransactionSchema: GenMessage<RawTransaction> = /*@__PURE__*/
  messageDesc(file_thru_core_v1_transaction, 4);

/**
 * TransactionView controls how transactions are materialized in responses.
 *
 * @generated from enum thru.core.v1.TransactionView
 */
export enum TransactionView {
  /**
   * @generated from enum value: TRANSACTION_VIEW_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRANSACTION_VIEW_SIGNATURE_ONLY = 1;
   */
  SIGNATURE_ONLY = 1,

  /**
   * @generated from enum value: TRANSACTION_VIEW_HEADER_ONLY = 2;
   */
  HEADER_ONLY = 2,

  /**
   * @generated from enum value: TRANSACTION_VIEW_HEADER_AND_BODY = 3;
   */
  HEADER_AND_BODY = 3,

  /**
   * @generated from enum value: TRANSACTION_VIEW_FULL = 4;
   */
  FULL = 4,
}

/**
 * Describes the enum thru.core.v1.TransactionView.
 */
export const TransactionViewSchema: GenEnum<TransactionView> = /*@__PURE__*/
  enumDesc(file_thru_core_v1_transaction, 0);

/**
 * TransactionVmError enumerates runtime error codes returned by the executor.
 *
 * @generated from enum thru.core.v1.TransactionVmError
 */
export enum TransactionVmError {
  /**
   * TN_RUNTIME_TXN_EXECUTE_SUCCESS
   *
   * @generated from enum value: TRANSACTION_VM_EXECUTE_SUCCESS = 0;
   */
  TRANSACTION_VM_EXECUTE_SUCCESS = 0,

  /**
   * TN_RUNTIME_TXN_ERR_INVALID_FORMAT
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_INVALID_FORMAT = -255;
   */
  TRANSACTION_VM_ERROR_INVALID_FORMAT = -255,

  /**
   * TN_RUNTIME_TXN_ERR_INVALID_VERSION
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_INVALID_VERSION = -254;
   */
  TRANSACTION_VM_ERROR_INVALID_VERSION = -254,

  /**
   * TN_RUNTIME_TXN_ERR_INVALID_FLAGS
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_INVALID_FLAGS = -253;
   */
  TRANSACTION_VM_ERROR_INVALID_FLAGS = -253,

  /**
   * TN_RUNTIME_TXN_ERR_INVALID_SIGNATURE
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_INVALID_SIGNATURE = -252;
   */
  TRANSACTION_VM_ERROR_INVALID_SIGNATURE = -252,

  /**
   * TN_RUNTIME_TXN_ERR_DUPLICATE_ACCOUNT
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_DUPLICATE_ACCOUNT = -251;
   */
  TRANSACTION_VM_ERROR_DUPLICATE_ACCOUNT = -251,

  /**
   * TN_RUNTIME_TXN_ERR_UNSORTED_ACCOUNTS
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_UNSORTED_ACCOUNTS = -250;
   */
  TRANSACTION_VM_ERROR_UNSORTED_ACCOUNTS = -250,

  /**
   * TN_RUNTIME_TXN_ERR_UNSORTED_READWRITE_ACCOUNTS
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_UNSORTED_READWRITE_ACCOUNTS = -249;
   */
  TRANSACTION_VM_ERROR_UNSORTED_READWRITE_ACCOUNTS = -249,

  /**
   * TN_RUNTIME_TXN_ERR_UNSORTED_READONLY_ACCOUNTS
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_UNSORTED_READONLY_ACCOUNTS = -248;
   */
  TRANSACTION_VM_ERROR_UNSORTED_READONLY_ACCOUNTS = -248,

  /**
   * TN_RUNTIME_TXN_ERR_ACCOUNT_COUNT_LIMIT_EXCEEDED
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_ACCOUNT_COUNT_LIMIT_EXCEEDED = -247;
   */
  TRANSACTION_VM_ERROR_ACCOUNT_COUNT_LIMIT_EXCEEDED = -247,

  /**
   * TN_RUNTIME_TXN_ERR_NONCE_TOO_LOW
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_NONCE_TOO_LOW = -511;
   */
  TRANSACTION_VM_ERROR_NONCE_TOO_LOW = -511,

  /**
   * TN_RUNTIME_TXN_ERR_NONCE_TOO_HIGH
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_NONCE_TOO_HIGH = -510;
   */
  TRANSACTION_VM_ERROR_NONCE_TOO_HIGH = -510,

  /**
   * TN_RUNTIME_TXN_ERR_INSUFFICIENT_FEE_PAYER_BALANCE
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_INSUFFICIENT_FEE_PAYER_BALANCE = -509;
   */
  TRANSACTION_VM_ERROR_INSUFFICIENT_FEE_PAYER_BALANCE = -509,

  /**
   * TN_RUNTIME_TXN_ERR_FEE_PAYER_ACCOUNT_DOES_NOT_EXIST
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_FEE_PAYER_ACCOUNT_DOES_NOT_EXIST = -508;
   */
  TRANSACTION_VM_ERROR_FEE_PAYER_ACCOUNT_DOES_NOT_EXIST = -508,

  /**
   * TN_RUNTIME_TXN_ERR_NOT_LIVE_YET
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_NOT_LIVE_YET = -507;
   */
  TRANSACTION_VM_ERROR_NOT_LIVE_YET = -507,

  /**
   * TN_RUNTIME_TXN_ERR_EXPIRED
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_EXPIRED = -506;
   */
  TRANSACTION_VM_ERROR_EXPIRED = -506,

  /**
   * TN_RUNTIME_TXN_ERR_INVALID_FEE_PAYER_STATE_PROOF
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_INVALID_FEE_PAYER_STATE_PROOF = -505;
   */
  TRANSACTION_VM_ERROR_INVALID_FEE_PAYER_STATE_PROOF = -505,

  /**
   * TN_RUNTIME_TXN_ERR_INVALID_FEE_PAYER_STATE_PROOF_TYPE
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_INVALID_FEE_PAYER_STATE_PROOF_TYPE = -504;
   */
  TRANSACTION_VM_ERROR_INVALID_FEE_PAYER_STATE_PROOF_TYPE = -504,

  /**
   * TN_RUNTIME_TXN_ERR_INVALID_FEE_PAYER_STATE_PROOF_SLOT
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_INVALID_FEE_PAYER_STATE_PROOF_SLOT = -503;
   */
  TRANSACTION_VM_ERROR_INVALID_FEE_PAYER_STATE_PROOF_SLOT = -503,

  /**
   * TN_RUNTIME_TXN_ERR_INVALID_FEE_PAYER_ACCOUNT_OWNER
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_INVALID_FEE_PAYER_ACCOUNT_OWNER = -502;
   */
  TRANSACTION_VM_ERROR_INVALID_FEE_PAYER_ACCOUNT_OWNER = -502,

  /**
   * TN_RUNTIME_TXN_ERR_INVALID_FEE_PAYER_STATE_PROOF_ACCOUNT_OWNER
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_INVALID_FEE_PAYER_STATE_PROOF_ACCOUNT_OWNER = -501;
   */
  TRANSACTION_VM_ERROR_INVALID_FEE_PAYER_STATE_PROOF_ACCOUNT_OWNER = -501,

  /**
   * TN_RUNTIME_TXN_ERR_INVALID_FEE_PAYER_STATE_PROOF_ACCOUNT_META_DATA_SZ
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_INVALID_FEE_PAYER_STATE_PROOF_ACCOUNT_META_DATA_SZ = -500;
   */
  TRANSACTION_VM_ERROR_INVALID_FEE_PAYER_STATE_PROOF_ACCOUNT_META_DATA_SZ = -500,

  /**
   * TN_RUNTIME_TXN_ERR_FEE_PAYER_ACTIVATION_REQUIRES_STATE_UNIT
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_FEE_PAYER_ACTIVATION_REQUIRES_STATE_UNIT = -497;
   */
  TRANSACTION_VM_ERROR_FEE_PAYER_ACTIVATION_REQUIRES_STATE_UNIT = -497,

  /**
   * TN_RUNTIME_TXN_ERR_BLOCK_STATE_BUDGET_EXCEEDED
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_BLOCK_STATE_BUDGET_EXCEEDED = -496;
   */
  TRANSACTION_VM_ERROR_BLOCK_STATE_BUDGET_EXCEEDED = -496,

  /**
   * TN_RUNTIME_TXN_ERR_VM_FAILED
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_VM_FAILED = -767;
   */
  TRANSACTION_VM_ERROR_VM_FAILED = -767,

  /**
   * TN_RUNTIME_TXN_ERR_INVALID_PROGRAM_ACCOUNT
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_INVALID_PROGRAM_ACCOUNT = -766;
   */
  TRANSACTION_VM_ERROR_INVALID_PROGRAM_ACCOUNT = -766,

  /**
   * TN_RUNTIME_TXN_ERR_VM_REVERT
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_VM_REVERT = -765;
   */
  TRANSACTION_VM_ERROR_VM_REVERT = -765,

  /**
   * TN_RUNTIME_TXN_ERR_CU_EXHAUSTED
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_CU_EXHAUSTED = -764;
   */
  TRANSACTION_VM_ERROR_CU_EXHAUSTED = -764,

  /**
   * TN_RUNTIME_TXN_ERR_SU_EXHAUSTED
   *
   * @generated from enum value: TRANSACTION_VM_ERROR_SU_EXHAUSTED = -763;
   */
  TRANSACTION_VM_ERROR_SU_EXHAUSTED = -763,
}

/**
 * Describes the enum thru.core.v1.TransactionVmError.
 */
export const TransactionVmErrorSchema: GenEnum<TransactionVmError> = /*@__PURE__*/
  enumDesc(file_thru_core_v1_transaction, 1);

